function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#666666;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#0071BC;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#046499;}\r\n\t.st3{fill:#F2F2F2;}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#F2F2F2;}\r\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#666666;}\r\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("polygon", {
  className: "st1",
  points: "181.6,43.3 181.6,74.9 148.4,94 115.3,113.1 115.3,179.1 148.4,205.8 148.4,132.3 148.4,128.4  214.7,90.2 214.7,43.3 181.6,43.3  "
}), React.createElement("polygon", {
  className: "st2",
  points: "148.4,83 148.4,43.3 115.3,43.3 115.3,102.1 148.4,83  "
}), React.createElement("polygon", {
  className: "st2",
  points: "158,133.9 181.6,147.5 181.6,206.7 214.7,179.1 214.7,128.4 191.1,114.8 158,133.9  "
}));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 330 250",
    style: {
      enableBackground: "new 0 0 330 250"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.e79a004d.svg";
export { ForwardRef as ReactComponent };